import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './projects.css';

const meetingRoomImages = [
  { id: 1, thumbnail: '../images/interior5/БИЗНЕС_ПЕРЕГОВОРНАЯ.png', fullImage: '../images/interior5/БИЗНЕС_ПЕРЕГОВОРНАЯ.png' },
  { id: 2, thumbnail: '../images/interior5/БИЗНЕС_ПЕРЕГОВОРНАЯ_!.png', fullImage: '../images/interior5/БИЗНЕС_ПЕРЕГОВОРНАЯ_!.png' },
  { id: 3, thumbnail: '../images/interior5/БИЗНЕС_ПЕРЕГОВОРНАЯ_ВАРИАНТ.png', fullImage: '../images/interior5/БИЗНЕС_ПЕРЕГОВОРНАЯ_ВАРИАНТ.png' },
  { id: 4, thumbnail: '../images/interior5/МАЛАЯ ПЕРЕГОВОРНАЯ_1.png', fullImage: '../images/interior5/МАЛАЯ ПЕРЕГОВОРНАЯ_1.png' },
  { id: 5, thumbnail: '../images/interior5/МАЛАЯ_ПЕРЕГОВОРНАЯ.png', fullImage: '../images/interior5/МАЛАЯ_ПЕРЕГОВОРНАЯ.png' },
  { id: 6, thumbnail: '../images/interior5/МАЛАЯ_ПЕРЕГОВОРНАЯ_2.png', fullImage: '../images/interior5/МАЛАЯ_ПЕРЕГОВОРНАЯ_2.png' },
  { id: 7, thumbnail: '../images/interior5/ОФИС В.png', fullImage: '../images/interior5/ОФИС В.png' },
  { id: 8, thumbnail: '../images/interior5/ОФИС.png', fullImage: '../images/interior5/ОФИС.png' },
  { id: 9, thumbnail: '../images/interior5/ОФИСНАЯ_ЗОНА.png', fullImage: '../images/interior5/ОФИСНАЯ_ЗОНА.png' },
  { id: 10, thumbnail: '../images/interior5/ПЕРЕГОВОРНАЯ.png', fullImage: '../images/interior5/ПЕРЕГОВОРНАЯ.png' },
  { id: 11, thumbnail: '../images/interior5/ПЕРЕГОВОРНАЯ_1.png', fullImage: '../images/interior5/ПЕРЕГОВОРНАЯ_1.png' },
  // Add more images as needed
];

function MeetingRoom() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/interior-designs');
  };

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  const handleClose = () => {
    setSelectedImageIndex(null);
  };

  const handlePrev = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : meetingRoomImages.length - 1));
  };

  const handleNext = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex < meetingRoomImages.length - 1 ? prevIndex + 1 : 0));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (selectedImageIndex !== null) {
        if (event.key === 'ArrowLeft') {
          handlePrev();
        } else if (event.key === 'ArrowRight') {
          handleNext();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImageIndex]);

  return (
    <div className="project-detail">
      <button className="back-button" onClick={handleBack}>НАЗАД ВО ВСЕ ИНТЕРЬЕРЫ</button>
      <div className="project-detail-grid">
        {meetingRoomImages.map((image, index) => (
          <div key={image.id} className="project-detail-item">
            <img
              src={image.thumbnail}
              alt={`Meeting Room Image ${index + 1}`}
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>

      <button className="back-button back-button-end" onClick={handleBack}>НАЗАД ВО ВСЕ ИНТЕРЬЕРЫ</button>

      {selectedImageIndex !== null && (
        <div className="project-popup" onClick={handleClose}>
          <div className="project-popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleClose}>X</button>
            <button className="nav-button left" onClick={handlePrev}>&lt;</button>
            <img src={meetingRoomImages[selectedImageIndex].fullImage} alt={`Meeting Room Image ${selectedImageIndex + 1}`} />
            <button className="nav-button right" onClick={handleNext}>&gt;</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default MeetingRoom; 